module.exports = __webpack_public_path__ + "img/gt.d6b5b664.svg";